import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from '@mui/material';
import {
  DialogHeader,
  FP,
  fpDialogActionsSx,
  fpDialogPaperProps,
} from './lib/ui';

const AddSectionModal = ({ open, onClose, onCreate }) => {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!name.trim() || busy) return;
    setBusy(true);
    try {
      await onCreate(name.trim());
      setName('');
      onClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={fpDialogPaperProps}
    >
      <DialogHeader
        title="Add section"
        subtitle="Give the area a name guests will recognize."
        onClose={onClose}
      />
      <DialogContent sx={{ px: 3 }}>
        <TextField
          autoFocus
          fullWidth
          label="Section name"
          placeholder="e.g. Patio, Main Hall, Bar"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions sx={fpDialogActionsSx}>
        <Button onClick={onClose} disabled={busy} sx={{ textTransform: 'none' }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!name.trim() || busy}
          onClick={submit}
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            px: 2.5,
            bgcolor: FP.primary,
            '&:hover': { bgcolor: FP.primaryDark },
          }}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddSectionModal;
